import { useDefineProviderRoute } from "@versatile-credit-apply/composition"
import { type RouteRecordRaw } from "vue-router"
import {
  ScreenId,
  type StaticProviderKey,
} from "@versatile-credit-apply/omni-apply-client"

const providerKey: StaticProviderKey = "proceed_standard"
const { defineRoute } = useDefineProviderRoute(providerKey)

export const routes: RouteRecordRaw[] = [
  defineRoute({
    path: "/apply/:applyStage/responses/prequalified",
    inherit: true,
    component: () => import("@/views/apply/ExploreOffersView.vue"),
    meta: {
      screenId: ScreenId.OFFER_PRESENTATION_PREQUAL,
    },
  }),

  defineRoute({
    path: "/apply/offer/selected",
    component: () =>
      import("@/providers/proceed_standard/views/ProceedOfferSelectedView.vue"),
  }),

  defineRoute({
    path: "/apply/prequalify/completed",
    component: () =>
      import("@/providers/proceed_standard/views/ProceedCompletedView.vue"),
  }),

  defineRoute({
    path: "/apply/:applyStage/:planCode/review",
    inherit: true,
    component: () =>
      import("@/providers/proceed_standard/views/ProceedReviewOffer.vue"),
  }),
]
